/* global VeloxWebView, VeloxViewController */
var OptinController = VeloxViewController.create({
    directory : "views/optin",
    name: "optin",
    container: "main",
    route: "optin"
}) ;

OptinController.prototype.prepareDataOnEnter = function(token, callback){
    //normal login
    this.api.public.getOptin(token, callback) ;
};

OptinController.prototype.onValidate = function(){
    this.view.updateData() ;

    this.view.longTask(function(done){
        this.api.public.updateOptin(this.data.c_id, this.data.c_optin_newsletter, this.data.c_optin_bayrol, this.data.c_optin_dealer, function(err){
            if(err){ 
                return done(null, err);
            }
            done() ;
            this.view.info(this.view.tr("optin.updateSuccess"), function(){
                window.location.reload() ;
            }) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = new OptinController() ;